export const getTheme = (darkMode) => ({
  bg: darkMode ? "#080808" : "#fafaf8",
  fg: darkMode ? "#e8e4dc" : "#111111",
  muted: darkMode ? "#555" : "#888",
  accent: "#84cc16", // lime-500 — works on both bg
  border: darkMode ? "#1e1e1e" : "#e8e8e4",
  cardBg: darkMode ? "#111" : "#f2f2ee",
  darkMode,
});